import React, { useCallback } from 'react';
import WarningOutlined from 'assets/warning_outline.svg?react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RoutePaths } from '../../../routes/history';
import { useHistory } from 'react-router-dom';
import { useMisalignmentsCount } from '../../FieldMatching/hooks/use-misalignment-count.hook';

export const MisalignmentBanner = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const misalignmentCount = useMisalignmentsCount();

  const handleOnClick = useCallback(() => {
    history.push(RoutePaths.FieldMatchingView());
  }, [history]);

  if (!misalignmentCount) return null;

  return (
    <div className="flex p-16 bg-yellow-10 text-left">
      <WarningOutlined />

      <div className="pl-8">
        <h6>
          <span className="bold pr-2">{misalignmentCount}</span>
          {t('field_matching.misalignment_banner.title', { count: misalignmentCount })}
        </h6>
        <div className="flex mt-6">
          <p className="">{t('field_matching.misalignment_banner.description')}</p>
          <div className="pl-8">
            <Button size="small" onClick={handleOnClick}>
              {t('field_matching.misalignment_banner.redirect_button')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
